import {Injectable, OnDestroy} from '@angular/core';
import {ViewFault} from '@docma-mm-core/fault/fault';
import {SelectionService} from '@mydocma/component-library/src/lib/selection';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export class MmFaultsSelectionService extends SelectionService<ViewFault> implements OnDestroy {

  constructor() {
    super();

    this.itemSelectionChange
    .pipe(untilDestroyed(this))
    .subscribe(fi => {
      if (fi?.item) {
        fi.item.isChecked = fi.selected;
      }
    });
  }

  ngOnDestroy(): void {
  }

  toggleSelection(fault: ViewFault) {
    if (fault.isChecked) {
      this.deselectItem(fault);
    } else {
      this.selectItem(fault);
    }
  }

  compareItems(item1: ViewFault, item2: ViewFault): boolean {
    return (item1?.id && item1.id ===  item2.id) || (item1?.uid && item1.uid === item2.uid);
  }
  //
  deselectItem(item: ViewFault, switchModeIfNoItemsSelected?: boolean) {
    super.deselectItem(item, false);
  }

}
